/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { InsightBadgeComponent } from '../insight-badge.component';
import { InsightBadge } from '../InsightBadge';

@Component({
  selector: 'app-insight-review-badge',
  templateUrl: '../insight-badge/insight-badge.component.html',
  styleUrls: ['../insight-badge/insight-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppVpcBadgeComponent
  implements InsightBadgeComponent, OnChanges, OnInit
{
  @Input() data: any;
  @Output() anchorClick: EventEmitter<string> = new EventEmitter<string>();
  badge!: InsightBadge;
  constructor(private _changeDector: ChangeDetectorRef) {}

  onAnchorClick(anchor: string) {
    this.anchorClick.emit(anchor);
  }

  ngOnInit() {
    this.updateBadge();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.updateBadge();
    }
  }

  updateBadge() {
    if (this.data) {
      let badge = {
        text: 'Verifiable Parental Consent',
        tooltip: 'Verifiable Parental Consent',
        anchorLink: '#app-coppa-permission-risk',
        detected: true,
        detectedText: 'Detected',
        badgeColor: 'green',
        icon: 'assets/images/icon-vpc-detected.svg'
      };

      if (this.data.coppaPermissions.vpcDetected === false) {
        badge = {
          ...badge,
          detectedText: 'Not Detected',
          badgeColor: 'red',
          icon: 'assets/images/icon-vpc-not-detected.svg'
        };
      }
      this.badge = badge;
      this._changeDector.markForCheck();
      this._changeDector.detectChanges();
    }
  }
}
